import russianToLatin from '@/utils/russianToLatin'

export default (txt, amprsd = 'and') => {
  return russianToLatin(txt).toString().toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/&/g, `-${amprsd}-`)
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '')
}
